import { ReactNode } from "react";
import { Box, NeoColor } from "@noom/wax-component-library";

type TreatmentCardStateContainerProps = {
  children: ReactNode;
};

export const TreatmentCardStateContainer = ({
  children,
}: TreatmentCardStateContainerProps) => (
  <Box
    width="100%"
    display="flex"
    flexDir="column"
    bg={NeoColor.greyscale.white}
    borderRadius="xl"
    overflow="hidden"
    boxShadow="0px 0px 4px 1px rgba(0, 0, 0, 0.06), 1px 2px 6px rgba(0, 0, 0, 0.08)"
  >
    {children}
  </Box>
);
